import { z } from 'zod'

/**
 * A rendered page: light or dark. The dashboard's resolved theme, an embed's
 * `theme` query, and the surface an accent color is measured against are this
 * same pair. Button text (`AccentForeground`) uses the same words for a
 * different choice (white vs ink) and is not this type.
 */
export const COLOR_SCHEMES = ['light', 'dark'] as const

export const colorSchemeSchema = z.enum(COLOR_SCHEMES)

export type ColorScheme = z.infer<typeof colorSchemeSchema>
